import Image from "next/image";
import React from "react";
import { Stack } from "~/components/Stack/Stack";
import { Text } from "~/components/Text/Text";
import { Button } from "../Button/Button";

export interface RedeemCodeErrorProps {
  message: string;
  onRetryVoucherCode: () => void;
  code: string;
}

export default function RedeemCodeError({
  code,
  message,
  onRetryVoucherCode,
}: RedeemCodeErrorProps): React.ReactElement {
  return (
    <Stack space="5" align="center">
      <Text align={"center"} font="accent" weight="strong" size="large">
        {code}
      </Text>
      <Image
        src="/images/jetserror.png"
        width={297}
        height={230}
        alt="Error Image"
      />
      <Text color="jets-black" size="large" weight="strong">
        {message}
      </Text>
      <Button primary onClick={onRetryVoucherCode}>
        Continue
      </Button>
    </Stack>
  );
}
